@layer module {
.transactions-table-container {
            overflow-x: auto;
    }

.transactions-table-container .customize-columns-button {
            display: flex;
            align-items: center;
            justify-content: flex-end;
    }

.transactions-table-container .tx-type-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
    }

.tx-type-row .details-inner {
            flex-shrink: 0;
    }

.transactions-table-container .details-inner {
            display: flex;
            align-items: center;
            justify-content: flex-end;
    }

.transactions-table-container .details-inner svg {
            cursor: pointer;
    }

.transactions-table-container :global(.status) {
            display: inline-block;
    }

.transactions-table-container .ellipsis {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
    }

.transactions-table-container :where(:global(.mm-table-view-container):not([data-layout='table'])) .ellipsis {
            overflow: visible;
            text-overflow: clip;
            white-space: normal;
            overflow-wrap: anywhere;
    }

.transactions-table-container .type-cell {
            display: flex;
            align-items: center;
            min-width: 0;
    }

.transactions-table-container .type-icon {
            display: grid;
            flex-shrink: 0;
            place-items: center;
            border-radius: 50%;
    }

.transactions-table-container .currency-cell {
            display: flex;
            align-items: center;
            white-space: nowrap;
    }

      @media (min-width: 1200px) {
                .transactions-table-container .customize-columns-button {
                        display: none;
                    }
          }
} // layer module










@layer app {
.transactions-table-container .customize-columns-button {
            width: 100%;
            gap: $size-8;
            padding: $size-12 $size-16;
    }

.transactions-table-container .tx-type-row {
            gap: $size-12;
    }

.transactions-table-container .ellipsis {
            max-width: $size-180;
    }

.transactions-table-container :where(:global(.mm-table-view-container):not([data-layout='table'])) .ellipsis {
            max-width: none;
    }

.transactions-table-container .type-cell {
            gap: $size-10;
    }

.transactions-table-container .type-icon {
            width: $size-28;
            height: $size-28;
    }

.transactions-table-container .currency-cell {
            gap: $size-6;
    }

.transactions-table-container :global(.status) {
            text-transform: lowercase;
    }

.transactions-table-container :global(.status)::first-letter {
            text-transform: uppercase;
    }

.transactions-table-container .type-icon {
            background: var(--color-brand-wash);
            color: var(--color-brand);
    }

.transactions-table-container .type-label {
            color: var(--text-primary);
            font-size: var(--font-size-base);
    }

.transactions-table-container .amount {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-variant-numeric: tabular-nums;
            font-weight: 500;
    }

.amount.muted {
            color: var(--text-faint);
    }

.amount.incoming {
            color: var(--color-success-text);
    }

.transactions-table-container .chevron {
            color: var(--text-faint);
    }
} // layer app










@layer context {
:global(.staff-latest-transactions) .transactions-table-container {
            display: flex;
            flex: 1 1 auto;
            flex-direction: column;
    }

      @media (min-width: 800px) {
                :global(.staff-latest-transactions) .transactions-table-container {
                        flex-basis: 0;
                        min-height: $size-100;
                    }
          }
} // layer context
